import { logger } from '../../datadog/logger';
import { applyProjection } from '../../utils/projection';
import {
  ALL_ZOOM_EVENTS,
  type VideoClientEvent,
  type VideoClientEventHandler,
  ZOOM_VIDEO_CLIENT_EVENTS,
} from './VideoClientEvents';
import { ZoomEventBus } from './ZoomEventBus';

export type ZoomEventListener = (event: VideoClientEvent, args: unknown[]) => void;

const IGNORED_ZOOM_EVENT_LOGS = new Set<VideoClientEvent>(['command-channel-message', 'video-statistic-data-change']);

export function subscribeToAllZoomEvents(eventBus: ZoomEventBus, listener: ZoomEventListener): () => void {
  const unsubscribers = ALL_ZOOM_EVENTS.map((event) => {
    const handler = ((...args: unknown[]) => listener(event, args)) as VideoClientEventHandler<typeof event>;
    eventBus.on(event, handler);
    return () => eventBus.off(event, handler);
  });

  return () => unsubscribers.forEach((unsubscribe) => unsubscribe());
}

export function selectZoomEventLogArgs(event: VideoClientEvent, args: unknown[]): unknown[] {
  try {
    return applyProjection(args, ZOOM_VIDEO_CLIENT_EVENTS[event]);
  } catch {
    return [];
  }
}

export function logZoomEvent(event: VideoClientEvent, args: unknown[]): void {
  if (IGNORED_ZOOM_EVENT_LOGS.has(event)) return;

  logger.info(`Zoom Video SDK event: ${event}`, {
    diagnostic: true,
    event: event,
    args: selectZoomEventLogArgs(event, args),
  });
}
